import type { ReactNode } from "react"
import { memo } from "react"

import { AI_CHAT_ACTOR_NAME } from "@productlane/lib/src/ai-chat-sync"
import { formatRelativeTime } from "@productlane/lib/src/date"
import { AgentOrb } from "@productlane/ui/src/components/agent-orb/agent-orb"

/** The timeline's agent avatar, one size down. */
export const AgentAvatar = memo(() => <AgentOrb size={20} />)

/** The agent's message: its avatar, name and time on one line, the text below, no bubble. */
export const AgentMessage = memo(
	({ at, children }: { at: number; children: ReactNode }) => {
		const valid = Number.isFinite(at) && at > 0
		return (
			<div className="flex flex-col gap-2">
				<div
					data-testid="agent-message-header"
					className="flex items-center gap-2 leading-5"
				>
					<AgentAvatar />
					<span className="min-w-0 truncate text-sm font-semibold text-primary">
						{AI_CHAT_ACTOR_NAME}
					</span>
					{valid && (
						<span className="flex-none text-xs tabular-nums text-tertiary">
							{formatRelativeTime(new Date(at))}
						</span>
					)}
				</div>
				{children}
			</div>
		)
	},
)
